<template>
  <div>
    <div class="flex-center">
      <div class="title">账户管理</div>
      <!-- <el-button type="primary" icon="el-icon-s-promotion" class="sign-button mr20 fz15">发起签章</el-button> -->
    </div>
    <div class="pt30">
      <el-tabs type="border-card">
        <el-tab-pane>
          <span slot="label"> <i class="el-icon-postcard"></i> 基本信息 </span>
          <div class="custom-item" v-if="$store.state.account.user.type == 1">
            <span class="mr40">个人账号</span>
            <span>{{ $store.state.account.user.code }}</span>
          </div>
          <div class="custom-item" v-if="$store.state.account.user.type == 1">
            <span class="mr40">真实姓名</span>
            <span>{{ $store.state.account.user.name }}</span>
          </div>
          <!--          <div class="custom-item" v-if="$store.state.account.user.type == 1">-->
          <!--            <span class="mr40">数字证书</span>-->
          <!--            &lt;!&ndash;            <span>{{ $store.state.account.user.name }}</span>&ndash;&gt;-->
          <!--            <el-button type="text" @click="visible = true">查看数字证书</el-button>-->
          <!--          </div>-->
          <div class="custom-item" v-if="$store.state.account.user.type == 2">
            <span class="mr40">信用代码</span>
            <span>{{ $store.state.account.user.code }}</span>
          </div>
          <div class="custom-item" v-if="$store.state.account.user.type == 2">
            <span class="mr40">企业名称</span>
            <span>{{ $store.state.account.user.name }}</span>
          </div>
          <div class="custom-item" v-if="$store.state.account.user.type == 2">
            <span class="mr40">法人姓名</span>
            <span>{{ $store.state.account.user.legalName }}</span>
          </div>
        </el-tab-pane>
        <el-tab-pane>
          <span slot="label"> <i class="el-icon-lock"></i> 安全中心 </span>
          <div class="lock-item">
            <div>
              <span class="mr40">安全手机</span>
              <span>{{ $store.state.account.user.telephone }}</span>
              <span class="auth-label">已实名认证</span>
            </div>
            <div class="fz14 fc9 mt10">用于登录活其他安全验证</div>
          </div>
          <div class="lock-item">
            <div>
              <span class="mr40">登录密码</span>
              <span>{{ basicInfo.password }}</span>
              <span @click="handleEdit" class="public-but">修改</span>
            </div>
            <div class="fz14 fc9 mt10">用于保护账号信息和登录安全</div>
          </div>
          <div class="lock-item">
            <div>
              <span class="mr40">签署密码</span>
              <span>********</span>
              <span @click="handleChangePin" class="public-but">修改</span>
              <span @click="handleResetPin" class="public-but public-warn">重置</span>
            </div>
            <div class="fz14 fc9 mt10">用于电子印章的安全签署</div>
          </div>
        </el-tab-pane>
      </el-tabs>
      <edit-dialog ref="editRef"></edit-dialog>
    </div>

    <ChangePinCode ref="changeRef"></ChangePinCode>
    <ReturnPassword ref="returnRef"></ReturnPassword>

    <digital-certificate
        v-if="visible"
        :visible.sync="visible"
    />
  </div>
</template>

<script>
import EditDialog from "./EditDialog.vue";
import ChangePinCode from './ChangePinCode.vue'
import ReturnPassword from './ReturnPassword.vue'
import DigitalCertificate from "./digitalCertificate.vue";

export default {
  components: {DigitalCertificate, EditDialog, ChangePinCode, ReturnPassword},
  data() {
    return {
      basicInfo: {
        account: "123",
        name: "宁闯",
        telephone: "1234566",
        password: "********",
      },
      visible: false,
    };
  },

  methods: {
    handleEdit() {
      this.$refs.editRef.show();
    },
    handleChangePin() {
      this.$refs.changeRef.show()
    },
    handleResetPin() {
      this.$refs.returnRef.show()
    }
  },
};
</script>
<style lang="less" scoped>
.title {
  border-top: 6px solid #407fff;
  width: 106px;
  font-weight: 400;
  font-size: 26px;
  color: #000;
  padding-top: 12px;
}

.custom-item {
  padding: 20px 15px;
  border-bottom: 1px solid #eee;
  font-size: 16px;
  text-align: left;

  &:last-child {
    border-bottom: none;
  }
}

.lock-item {
  padding: 20px 15px;
  border-bottom: 1px solid #eee;
  font-size: 16px;
  text-align: left;

  &:last-child {
    border-bottom: none;
  }

  .auth-label {
    background-color: #00cc69;
    border-radius: 9px 9px 9px 0;
    display: inline-block;
    font-weight: 300;
    color: #fff;
    font-style: normal;
    position: relative;
    padding: 0 5px;
    top: 0;
    font-size: 13px;
    margin-left: 20px;
  }

  .public-but {
    width: 60px;
    height: 24px;
    border: 1px solid #407fff;
    border-radius: 2px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #407fff;
    line-height: 24px;
    text-align: center;
    margin: 0 0 0 25px;
    cursor: pointer;
    display: inline-block;
  }

  .public-warn {
    border: 1px solid #F56C6C;
    color: #F56C6C;
  }
}

::v-deep .el-tabs__item {
  height: 48px;
  line-height: 48px;
}
</style>
